export const CONTROL_BANK = [

  {
    id: "ctl_01",

    dimension: "control",

    behaviour: "leadership",

    scenario: "group_assignment",

    text: "Your class is given a group assignment. You usually...",

    options: [
      {
        label: "Help organise the group and get everyone started",
        weights: { control: +2 }
      },
      {
        label: "Help when needed while doing your part",
        weights: { control: +1 }
      },
      {
        label: "Focus mainly on the part you've been given",
        weights: { control: 0 }
      },
      {
        label: "Prefer someone else to organise everything",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_02",

    dimension: "control",

    behaviour: "planning",

    scenario: "exam_preparation",

    text: "You have several tests coming up next week. You usually...",

    options: [
      {
        label: "Create a study plan before you begin",
        weights: { control: +2, flexibility: -1 }
      },
      {
        label: "Decide what to study each day",
        weights: { control: +1 }
      },
      {
        label: "Study whenever you have time",
        weights: { control: 0 }
      },
      {
        label: "Wait until the last minute to start",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_03",

    dimension: "control",

    behaviour: "initiative",

    scenario: "new_assignment",

    text: "Your teacher gives the class a new assignment. You usually...",

    options: [
      {
        label: "Start planning how you'll complete it",
        weights: { control: +2 }
      },
      {
        label: "Read through everything before getting started",
        weights: { control: +1, thinking: +1 }
      },
      {
        label: "Wait a while before beginning",
        weights: { control: 0 }
      },
      {
        label: "Only start when you're reminded",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_04",

    dimension: "control",

    behaviour: "decision_making",

    scenario: "group_disagreement",

    text: "Your group can't agree on what to do next. You usually...",

    options: [
      {
        label: "Help the group reach a decision",
        weights: { control: +2 }
      },
      {
        label: "Suggest a practical way forward",
        weights: { control: +1, thinking: +1 }
      },
      {
        label: "Support whatever the group decides",
        weights: { control: 0 }
      },
      {
        label: "Stay out of the discussion",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_05",

    dimension: "control",

    behaviour: "accountability",

    scenario: "assignment_mistake",

    text: "You realise you've made a mistake in an assignment you've already submitted. You usually...",

    options: [
      {
        label: "Accept the mistake and look for a way to correct it",
        weights: { control: +2 }
      },
      {
        label: "Learn from it so you don't repeat it",
        weights: { control: +1 }
      },
      {
        label: "Hope it doesn't affect your marks too much",
        weights: { control: 0 }
      },
      {
        label: "Blame something else for the mistake",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_06",

    dimension: "control",

    behaviour: "organisation",

    scenario: "multiple_assignments",

    text: "You have several assignments due around the same time. You usually...",

    options: [
      {
        label: "Organise your work so everything gets done on time",
        weights: { control: +2 }
      },
      {
        label: "Finish the most urgent ones first",
        weights: { control: +1 }
      },
      {
        label: "Work on whichever one you feel like doing",
        weights: { control: 0 }
      },
      {
        label: "Deal with them only when deadlines are very close",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_07",

    dimension: "control",

    behaviour: "delegation",

    scenario: "sharing_tasks",

    text: "Your group needs to share the work fairly. You usually...",

    options: [
      {
        label: "Help match tasks to each person's strengths",
        weights: { control: +2, affection: +1 }
      },
      {
        label: "Help everyone agree on who does what",
        weights: { control: +1 }
      },
      {
        label: "Take whichever task is left",
        weights: { control: 0 }
      },
      {
        label: "Wait for someone else to decide everything",
        weights: { control: -2 }
      }
    ]
  },

  {
    id: "ctl_08",

    dimension: "control",

    behaviour: "ownership",

    scenario: "independent_task",

    text: "Your teacher gives you a difficult task to complete on your own. You usually...",

    options: [
      {
        label: "Take responsibility and work through it step by step",
        weights: { control: +2, thinking: +1 }
      },
      {
        label: "Ask a few questions before getting started",
        weights: { control: +1 }
      },
      {
        label: "Wait until you have more guidance",
        weights: { control: 0 }
      },
      {
        label: "Hope someone else can help you do most of it",
        weights: { control: -2 }
      }
    ]
  },

];

